module.exports = __webpack_public_path__ + "static/media/V.612f8f77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/V.svg
// module id = 289
// module chunks = 0